var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisapora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119",
    transform: "translate(-131 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    transform: "translate(131 3231)",
    fill: "#f5f5de",
    stroke: "#f0f0f0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    transform: "translate(152.119 3273.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M84.643,21.57a23.515,23.515,0,0,0-5.024-2.384.747.747,0,0,0-.2-.06,21.832,21.832,0,0,0-12.174-.483l-.468.136a36.251,36.251,0,0,0-5.959,2.173L58.5,21.992,44.891,19.548l-.6-.06-7.347,3.289A1.779,1.779,0,0,0,35.9,24.406a1.742,1.742,0,0,0,1.041,1.614l6.306,2.821L28.719,35.359,17.887,29.852a1.814,1.814,0,0,0-1.509-.03l-6.351,2.851a1.742,1.742,0,0,0-1.011,1.388,1.82,1.82,0,0,0,.664,1.675L18.158,42.6c.241,1.177,1.418,5.024,6.668,5.054h.06a81.618,81.618,0,0,0,11.194-1.388c2.836-.483,5.642-1.132,8.4-1.871l-4.631,8.841a1.791,1.791,0,0,0,.347,2.022,1.745,1.745,0,0,0,1.282.543,1.889,1.889,0,0,0,.754-.166l9.052-4.058a1.791,1.791,0,0,0,.785-.694L59.947,38.8c6.381-2.746,13.819-5.99,18.978-8.705a33.116,33.116,0,0,0,3.53-2.157L84.7,26.382l.136-.121A3.09,3.09,0,0,0,85.925,23.7,2.754,2.754,0,0,0,84.643,21.57ZM40.7,24.391l4.043-1.81,8.871,1.6-6.668,3ZM13.09,34.6l3.968-1.78,2.61,1.328L15.081,36.2ZM49.734,48.952,44.2,51.442l7.256-13.835L59.494,34Zm31-23.505a27.6,27.6,0,0,1-3.213,1.976c-3.983,2.1-9.368,4.526-14.573,6.789L64.322,32.1a1.793,1.793,0,0,0-.2-2.112,1.82,1.82,0,0,0-2.112-.437L49.869,35.012a1.779,1.779,0,0,0-.905.845l-2.55,4.873a86.223,86.223,0,0,1-10.832,2.565,78.535,78.535,0,0,1-10.741,1.343c-2.64-.015-3.485-1.448-3.726-2.64a3.084,3.084,0,0,0-1.086-1.81l-2.308-1.856,5.4-2.429,4.36,2.218a2.64,2.64,0,0,0,2.308.06L62.059,23.7a34.96,34.96,0,0,1,5.506-2.007l.422-.121a18.9,18.9,0,0,1,6.155-.483L70.778,22.6a1.507,1.507,0,0,0-.754,1.991,1.489,1.489,0,0,0,1.991.769l7.075-3.183A19.922,19.922,0,0,1,82.832,24Z",
    transform: "translate(-1.458 -18)",
    fill: "#335f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M38.6,41.387,31.669,44.5a1.509,1.509,0,0,0,.619,2.885,1.49,1.49,0,0,0,.616-.133l6.935-3.114A1.508,1.508,0,1,0,38.6,41.387ZM27.646,46.308l-2.817,1.265a1.509,1.509,0,0,0,.619,2.885,1.49,1.49,0,0,0,.616-.133L28.88,49.06a1.508,1.508,0,1,0-1.235-2.752ZM12.968,43.232,19.9,40.118a1.509,1.509,0,0,0-1.238-2.752L11.73,40.48a1.509,1.509,0,1,0,1.238,2.752Zm-5.259-.944L4.892,43.553a1.509,1.509,0,0,0,.619,2.885,1.49,1.49,0,0,0,.616-.133L8.943,45.04a1.508,1.508,0,1,0-1.235-2.752Zm12.418.992-6.933,3.114a1.509,1.509,0,1,0,1.238,2.752l6.933-3.114a1.509,1.509,0,0,0-1.238-2.752Zm5.261.945L28.2,42.96a1.508,1.508,0,1,0-1.235-2.752l-2.817,1.265a1.509,1.509,0,0,0,.619,2.885A1.49,1.49,0,0,0,25.387,44.225Z",
    transform: "translate(-4 -8.22)",
    fill: "#335f32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapora);
export default __webpack_public_path__ + "static/media/disapora.f8f597b95875bbfa91ae4faa768cbc61.svg";
export { ForwardRef as ReactComponent };